import { saveTinSurface } from './../SurveyListDataGrid/SurveyListDataGridVM';
import { observable, action } from 'mobx';
import stores from 'cd-eft/models/Stores';
import { DisplayAlignment } from '../Maps/SETMapFunctions/loadLayers';
import { appConfig } from 'cd-eft/config/AppConfig';
import * as SETAPI from 'cd-eft/services/eftSetApi';
import { removeSingleLayerFromMap } from '../SurveySummary/SurveySummaryVM';
import { DesignContainerVM } from '../../Design/DesignContainer/DesignContainerVM';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';

const gisModel = stores.AppStore.surveyEngineeringStore.gisModel;
const setStore = stores.AppStore.surveyEngineeringStore;
const alignmentStore = stores.AppStore.alignmentDesignStore;
const designStore = stores.AppStore.designStore;
const surveyTypeSpredsheet = appConfig.hardCodes.surveyTypeSpredsheet; // 2
const currentWkid = appConfig.tempHardCodes.wkid;

export class SOSurveyActionsVM {
  @observable props;

  constructor(props: any) {
    this.props = props;
  }

  @action.bound async cancelEditHandler() {
    const i = setStore.selectedSurveysInfo.indexOf(setStore.currentSurvey.surveyId);
    if (i !== -1) setStore.selectedSurveysInfo.splice(i, 1);
    removeSingleLayerFromMap(setStore.currentSurvey.surveyId);
    setStore.resetSOSurvey();
    alignmentStore.resetCurrentObject();
    setStore.displaySurfaceChecked = false;
    await DesignContainerVM.loadOriginalSurface();
  }

  @action.bound displaySurveyHandler(e: any) {
    e.preventDefault();
    const surveyType = setStore.currentSurvey.surveyType;
    const postJSON = setStore.stationOffsetObject;
    displaySingleSOSurvey(surveyType, postJSON);
  }
}

export const displaySingleSOSurvey = async (surveyType, postJSON) => {
  designStore.setLoader('Loading Survey...');
  const generateSurveyAPI =
    surveyType === surveyTypeSpredsheet
      ? 'generateSOSurveyXYZPointsUsingPOST'
      : 'generateSOSurveyXYZPointsFromCrossSlopeUsingPOST';
  postJSON.surfaceDefId = designStore.currentSurface.surfaceDefId;
  postJSON.surfaceName = designStore.currentSurface.surfaceDefTitle;
  const layerId = postJSON.surveyId ? postJSON.surveyId : 'new_survey';
  try {
    const response: any = await SETAPI.SetSurveyStationOffsetController[generateSurveyAPI](postJSON);
    DisplayAlignment(gisModel.map, response.data, postJSON.surveyName, layerId, '', currentWkid);
    if (setStore.displaySurfaceChecked) {
      await DesignContainerVM.loadSurfaceFromData(response.data.tinTriangles!, undefined, response.data.contourLines);
    } else {
      await DesignContainerVM.loadOriginalSurface();
    }
    MessageCenter.clearMessages();
    if (setStore.selectedSurveysInfo.indexOf(layerId) === -1) setStore.selectedSurveysInfo.push(layerId);
  } catch (err) {
    MessageCenter.addError((err as Error).message);
  } finally {
    designStore.setLoader('');
  }
};

export const saveSOSurveyHandler = async (e: any) => {
  e.preventDefault();
  if (setStore.stationOffsetObject.alignmentStations.length < 2) {
    await MessageCenter.addErrorFromCode('Survey_06'); // 'Please add at least two stations.'
    return;
  }

  designStore.setLoader('Saving Survey...');
  const saveSurveyAPI =
    setStore.currentSurvey.surveyType === surveyTypeSpredsheet
      ? 'saveSOSurveyUsingPOST'
      : 'saveSOSurveyCrossSlopeUsingPOST';
  try {
    const postJSON = setStore.stationOffsetObject;
    postJSON.surfaceDefId = designStore.currentSurface.surfaceDefId;
    await SETAPI.SetSurveyStationOffsetController[saveSurveyAPI](postJSON);
    await saveTinSurface();
    await DesignContainerVM.loadOriginalSurface();
    const layerIdToRemove = setStore.currentSurvey.surveyId ? setStore.currentSurvey.surveyId : 'new_survey';
    removeSingleLayerFromMap(layerIdToRemove);
    setStore.reset();
    alignmentStore.resetCurrentObject();
  } catch (error) {
    MessageCenter.addError((error as Error).message);
  } finally {
    designStore.setLoader('');
  }
};
